import { CoObjectItem, TgkAmountObjectSource, TgkTableObjectSource } from "../../components/interfaces/CoObject";
import { DimensionDetail } from "../../api/models/dimension-detail";
import { SourceTypeEnum } from "../../api/models/source-type-enum";
import { CoObjectTypeEnum } from "../../api/models";

export function validateString(param: string): boolean {
  return !(undefined === param || null === param || "" === param);
}

export function removeUnderscores(param: string): string {
  return param.replace("_", "-");
}

export function normalizeDocumentName(documentName: string) {
  return documentName + (documentName.endsWith(".docx") ? "" : ".docx");
}

export const validateDimensionsAndParams = (coObject: CoObjectItem, validate: (item: DimensionDetail) => boolean) => {
  for (const p of coObject?.parameters ?? []) {
    if (!validate(p as DimensionDetail)) return false;
  }
  for (const p of coObject?.source?.dimensions ?? []) {
    if (!validate(p)) return false;
  }
  return true;
};

export const coObjectIsWithoutParameters = (coObject: CoObjectItem) => {
  //check if objects parameter need to be checked
  return (
    (coObject.info.objectType != "TABLE" ||
      (coObject.info.objectType == "TABLE" &&
        (coObject.source as TgkTableObjectSource).objectSource == SourceTypeEnum.EXCEL)) &&
    coObject.info.objectType != "CHART"
  );
};

export const coObjectIsWithoutDimensions = (coObject: CoObjectItem) => {
  if (!coObject) return true;
  const source = coObject.source as TgkAmountObjectSource;
  switch (coObject.info?.objectType) {
    case CoObjectTypeEnum.AMOUNT:
      return source?.objectSource && source.objectSource !== SourceTypeEnum.TAGETIK;
    case CoObjectTypeEnum.AMOUNT_AIH:
    case CoObjectTypeEnum.DIMENSION_ATTRIBUTE:
    case CoObjectTypeEnum.TGK_TEXT:
      return false;
    default:
      return true;
  }
};
